import NonCriticalAsyncComponent from './NonCriticalAsyncComponent';

export default NonCriticalAsyncComponent;
